import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-report-payment',

  templateUrl: './report-payment.component.html',

  styleUrls: ['./report-payment.component.css']

})

export class ReportPaymentComponent implements OnInit {

  lst_Report: any = [];

  lst_Search: any = [];

  URL_ENDPOINT: string = '';

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    // strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD')),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.route.parent?.url.subscribe(urlSegments => {

      if (urlSegments[0]?.path == 'emdadran') {

        return this.URL_ENDPOINT = 'EmdadRan_PaymentReport_Report';

      }

      if (urlSegments[0]?.path == 'taxiLon') {

        return this.URL_ENDPOINT = 'TaxiLon_PaymentReport_Report';

      }

      else {

        this.URL_ENDPOINT = 'FleetYar_PaymentReport_Report';

      }

    });

  }

  search_Report = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(this.URL_ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Report = res;

    this.lst_Search = res;

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'گزارش پرداخت ها.xlsx');
  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el?.strRefId?.includes(val.value) ||

        el.iPaymentReport?.toString().includes(val.value) ||

        el.strComment?.includes(val.value) ||

        el.strFullName?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.toString().replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

}
